/** 付款凭证的回填口径比费用申请更严格：账单金额/开票日不是实际到账证据。 */
import { reviewedScanFields } from "../../lib/documentScanner";

export function reviewedPaymentFields(recognition) {
  const fields = reviewedScanFields(recognition);
  const warnings = new Set(recognition?.warnings || []);
  if (warnings.has("invoice_date_not_payment_date") || warnings.has("invoice_not_proof_of_payment")) {
    delete fields.date;
    delete fields.payDate;
  }
  if (warnings.has("invoice_not_proof_of_payment")) {
    delete fields.amount;
    delete fields.paymentMethod;
  }
  return fields;
}
